<template>
  <!-- Fragment root so Board becomes .page-view > .pm-page (same as Plan Management) -->
  <div v-if="isHubIndex" class="container-fluid pm-page">
    <div class="pm-page-header pb-3">
      <h5 class="mb-0 font-weight-bold">Project Management</h5>
      <p class="text-secondary text-sm mb-0">
        See all sub-projects or your own timeline. Pick a sub-menu from the sidebar.
      </p>
    </div>
  </div>
  <router-view v-else />
</template>

<script>
export default {
  name: "project-overview-hub",
  computed: {
    isHubIndex() {
      const path = (this.$route.path || "").replace(/\/$/, "");
      return path === "/project-overview";
    },
  },
  watch: {
    isHubIndex: {
      immediate: true,
      handler(isIndex) {
        // Child Board owns lock on /all and /my — only lock here on hub index.
        if (isIndex) {
          document.documentElement.classList.add("pm-scroll-lock");
        }
      },
    },
  },
  beforeUnmount() {
    document.documentElement.classList.remove("pm-scroll-lock");
  },
};
</script>

<style scoped>
.pm-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}
</style>
